import { Button, Col, Row, Select, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ViewType } from '../../../components/fileView/FileType';
import { useFetchFileViewer } from '../../../components/fileView/FileViewer';
import { IModuleInfo } from '../../../redux/progress/module/moduleInterface';
import { IState } from '../../../redux/store';
import JobStatusViewer from '../ReflectModule/moduleParam/paramSubmit/JobStatusViewer';
import ModuleStatusViewer from '../ResonanceModule/moduleStatusViewer/ModuleStatusViewer';
import RealTimeHeader from './RealTimeHeader';
import RealTimeImage from './RealTimeImage';
import RealTimeParams from './RealTimeParams';
import RealTimeTitleBlock from './RealTimeTitleBlock';
import EasyModel from './easyRealTime/easyModel'
import { useParams } from 'react-router';
import ObservationSystem from './observationSystem'
import { clearProgress } from '../../../redux/progress/line/lineAction';
export interface RealTimeParamsPropies {
    module?: IModuleInfo;
    clearProgress: () => void
}


function RealTime(props: RealTimeParamsPropies) {
    const [show, jsx] = useFetchFileViewer();
    const [model, setModel] = useState('complexity')

    const { spec, tech } = useParams<{ spec: string, tech: string }>();
    const [surveyedit, setSurveyedit] = useState<{ line: string | number, point: string | number, devno: string | number } | null |undefined>()
    const { TabPane } = Tabs;
    const [tableDisable, setTableDisable] = useState<boolean>(false)
    const [tableClick, setTableClick] = useState(false)
    useEffect(() => {
        return () => {
            props.clearProgress();
        }
    })
    return <>
        <RealTimeHeader />

        {
            tech === 'ftresonance' ? <EasyModel /> : <Row gutter={25}>
                <Col span={5}>
                    {/* 左侧模块参数 */}
                    <RealTimeParams surveyData = {surveyedit} disableTable = {setTableDisable} tableClick = {tableClick} tableEdit = {setTableClick}/>
                </Col>
                <Col span={19}>
                    <Tabs type="card" size='large' style={{ marginTop: 10, marginLeft: 10 }}>
                        <TabPane tab="观测系统" key="1">
                            < ObservationSystem surveyedit={setSurveyedit} disableTable = {tableDisable} tableClick = {setTableClick}/>
                        </TabPane>
                        <TabPane tab="运行结果图" key="2">
                            <RealTimeImage />
                        </TabPane>
                        <TabPane tab="运行信息" key="3">
                            <ModuleStatusViewer
                                addParam={{ 'FLOWTYPE': 'realtime', 'JOB_NAME': props.module?.PRO_MODULE_NAME || '' }}
                                logButton={(props) => {
                                    return <>
                                        <Button
                                            style={{
                                                backgroundColor: "#f2914a",
                                                color: "#fff",
                                                width: '130px',
                                                height: '36px',
                                                position: 'absolute',
                                                right: '-20px',
                                                bottom: '-20px',
                                            }}
                                            onClick={() => {
                                                show("运行日志", ViewType.TEXT, props.fetch);
                                            }}
                                        >
                                            日志显示
                                        </Button>
                                        {jsx}
                                    </>
                                }}
                                titleBlock={(children) => {
                                    return <RealTimeTitleBlock
                                        style={{ marginTop: '25px' }}
                                        title='运行信息'
                                        titleComponent={<JobStatusViewer styled={{ width: '180px', height: '30px', marginLeft: '25px' }} />} // 按钮状态
                                    >
                                        {/* 运行结果信息 */}
                                        <Col style={{ width: '100%', height: '130px' }}>
                                            {children}
                                        </Col>
                                    </RealTimeTitleBlock>
                                }}
                            />
                        </TabPane>
                    </Tabs>


                </Col>
            </Row>

        }



    </>
}

const mapStateToProps = (state: IState) => {
    const modules = state.progress.modules.modules;
    const activeIndex = state.progress.modules.activeIndex;
    return {
        module: modules[activeIndex],
    };
};

export default connect(
    mapStateToProps,
    { clearProgress },
)(RealTime);